export default "__VITE_ASSET__Bdpc3gUA__"